import { ActivitySidebarChrome } from '@/components/layout/activity-sidebar/activity-sidebar-chrome';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { BookTocStateProvider } from '@/contexts/book-toc-state';
import { PlatformNavSidebar } from '@/nav/platform-nav-sidebar';
import { GlobalTopBarChrome, GlobalTopBarProvider } from '@/providers/global-top-bar-provider';
import { PlatformSidebarOutletProvider } from '@/providers/platform-sidebar-outlet';
import { Outlet, useNavigation } from 'react-router';

function AuthenticatedShellContent() {
    const navigation = useNavigation();
    const isNavigating = navigation.state === 'loading';

    return (
        <SidebarProvider className="h-svh overflow-hidden">
            <PlatformNavSidebar />
            <SidebarInset className="relative min-h-0 overflow-hidden">
                <GlobalTopBarChrome />
                {isNavigating ? (
                    <div
                        role="progressbar"
                        aria-busy="true"
                        aria-label="Loading page"
                        className="pointer-events-none absolute inset-x-0 top-[49px] z-50 h-0.5 overflow-hidden"
                    >
                        <div className="bg-muted-foreground/40 h-full w-1/3 motion-safe:animate-[indeterminateProgress_1.2s_ease-in-out_infinite] motion-reduce:w-full" />
                    </div>
                ) : null}
                <div className="min-h-0 flex-1 overflow-hidden">
                    <Outlet />
                </div>
            </SidebarInset>
            <ActivitySidebarChrome />
        </SidebarProvider>
    );
}

export default function AuthenticatedShell() {
    return (
        <GlobalTopBarProvider>
            <PlatformSidebarOutletProvider>
                <BookTocStateProvider>
                    <AuthenticatedShellContent />
                </BookTocStateProvider>
            </PlatformSidebarOutletProvider>
        </GlobalTopBarProvider>
    );
}
